import Blue from "~/core";
import { toggle } from "../plugins";
new Blue({
  name: "Search Dropdown",
  selector: ".leadership-listing",
  setup(container) {
    const triggers = [...container.querySelectorAll('.leadership-listing__intro')];
    const relations = [];

    triggers.forEach(trigger => {
      const content = trigger.nextElementSibling;

      const toggleItem = new toggle({
        container,
        trigger,
        content,
        relations,
        on: {
          afterToggle(item) {
            if (item.isActive) {
              window.scrollBy({
                top: content.getBoundingClientRect().top - 32,
                behavior: 'smooth'
              });
            }
          }
        }

      });

      const dataGuid = trigger.getAttribute('data-guid');
      if (window.location.hash === `#${dataGuid}`) {
        toggleItem.toggle();
      }

      // trigger.addEventListener('click', () => {
      //   window.scrollBy({
      //     top: content.getBoundingClientRect().top,
      //     behavior: 'smooth'
      //   })
      //   toggleItem.toggle(

      //   )
      // })
      relations.push(toggleItem);
    })
  },
});

// new Blue({
//   name: "Search Dropdown",
//   selector: ".leadership-listing-card__intro",
//   setup(leader) {
//     const toggleDropdown = () => {
//       let activeDropdowns = document.querySelectorAll("[data-active]");
//       activeDropdowns.forEach((element) => {
//         element.removeAttribute("data-active");
//       });

//       let dataProfile = leader.nextElementSibling;
//       if(dataProfile.getAttribute('data-active')){
//         console.log("dont animate")
//         console.log(dataProfile.getAttribute('data-active'))
//         leader.toggleAttribute("data-active");
//         dataProfile.toggleAttribute("data-active");
//         dataProfile.style.transition=''
//       }else{
//         console.log("animate")

//         dataProfile.style.transition=' all .75s ease-out;'
//         leader.toggleAttribute("data-active");
//         dataProfile.toggleAttribute("data-active");
//       }

//       var headerOffset = 45;
//       var elementPosition = dataProfile.getBoundingClientRect().top;
//       var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth",
//       });

//     };
//     addEvents(leader, "click", toggleDropdown);
//   },
// });
